import {
  MainWrapper,
  ContentWrapper,
  TopWrapper,
  ContentBlock,
} from "../Print/index.stitches";
import ProjectTop from "../elements/ProjectTop";

function ShiftingFrontiers() {
  return (
    <MainWrapper>
      <ContentWrapper>hi policy pages</ContentWrapper>
    </MainWrapper>
  );
}

export default ShiftingFrontiers;
